import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { setTabTitle } from "@utils";
import SearchViewStore from "@state/stores/offer/search/SearchViewStore";
import { useRootAppStore } from "@hooks";
import { useLocation } from "react-router-dom";
import { TSearchPageParams } from "@features/offer/mobile/search/SearchPage";

export function useSearchStore(searchTerm: string) {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();
	const location = useLocation();
	const [previousSearchTerm, setPreviousSearchTerm] = useState("");
	const searchViewStore = useMemo(() => new SearchViewStore(rootStore), []);

	useEffect(() => {
		if (previousSearchTerm == searchTerm) {
			return;
		}
		setPreviousSearchTerm(searchTerm);
		setTabTitle(t("SEARCH.TITLE", { searchTerm: searchTerm }));

		let queryParams = Object.fromEntries(
			new URLSearchParams(location.search)
		) as unknown as TSearchPageParams;

		searchViewStore.rootStore.searchBarViewStore.setValue(searchTerm);
		searchViewStore.onInitialize(1, queryParams);

		//clear search on unmount
		return () => {
			searchViewStore.onDispose();
		};
	}, [searchTerm, location.search]);

	useEffect(() => {
		return () => {
			searchViewStore.rootStore.searchBarViewStore.setValue("");
			searchViewStore.onDispose();
		};
	}, []);

	return searchViewStore;
}
